var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { margin: "0px", padding: "0px" } },
    [
      _c("sys-select-base", {
        class: _vm.classe,
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          clearable: _vm.clearable,
          showAdd: _vm.showAdd,
          multiple: _vm.multiple,
          outlined: _vm.outlined,
          "auto-complete": _vm.autoComplete,
          dense: _vm.dense,
          hideDetails: _vm.hideDetails,
          classe: _vm.classe,
          "background-color": _vm.backgroundColor,
          color: _vm.color,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          onShowForm: function ($event) {
            _vm.showForm = true
          },
          change: function ($event) {
            return _vm.$emit("change", $event)
          },
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
      }),
      _c("sys-register-occupation-area", {
        attrs: { model: {}, show: _vm.showForm },
        on: {
          onCompleted: _vm.newItem,
          "update:show": function ($event) {
            _vm.showForm = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }